console.log(`
%c<- 80 columns min! ->
@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
@(((((((((((@@@@@@@@@@@@@@@@@@@@@@@@((((@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
@((((@@@@@(((@@@@@@@@@@@@@@@@@@@@@@@((((@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@((((@@@
@((((((((((((@@%((((((((@@@((((((((@((((@@((((@@((((((((((@@@(((((((((@(((((((((
@((((((((((@@@@@(((((((((@((((@@@@@@((((((((@@@@(((@@@@((((@((((@@@((((@@((((@@@
@((((@@@(((((@@(((@@@((((@%((((@@((@((((@(((((@@((((@@((((%@(((((@(((((@@(((((@(
@((((@@@@@((((@@(((((((((@@@@((((((@((((@@@(((((@@((((((@@@@@@@(((((@@@@@@@(((((
`,"color: blue; font-family:monospace; font-size: 10px");
console.log("%cEnjoying Rackoot? Thanks for checking us out!","color: black; font-size: 18px");

if (document.body.classList.contains('admin')) {
    run.parts.darkMode();
    run.admin.parts.rackootCreate();
    //run.admin.parts.rackootCreateSimple();
    run.admin.parts.rackootsSort();
    run.admin.parts.backgroundSelector();
    run.admin.parts.rackootsShortcuts();
    run.parts.rackootStyleSwitch();
    run.admin.parts.rackootFolders();
    run.admin.parts.sidebar();
    // run.admin.parts.csrfRefresh();
    run.admin.parts.keepAlive();

    if (module_enabled('superadmin')) {
        run.admin.parts.adminMessages();
    }
}

$(document).ready(function() {
    // run.parts.waves();
    run.parts.modals();
    run.parts.mainNavbar();
    run.parts.dataTables();
    run.parts.select2();
    run.parts.logoutConfirm();
    run.superadmin.parts.confirmTriggeredAction();
    run.parts.bsCustomFileInput();
    run.parts.phoneFieldCountrySelector();
    run.parts.tooltips();
    run.parts.btnCopyData();
    run.admin.pages.extensionChromeAuthorizing();
    run.parts.circleProgressBars();

    if (module_enabled('ads')) {
        run.admin.parts.rackootAdsTiles();
    }
    
    //run.admin.parts.tileOpenFile();

    if (module_enabled('superadmin')) {
        if (document.body.classList.contains('admin')) {
            run.superadmin.parts.clock();
        }
    }

    // Switch pages
    switch (document.body.id) {
        case 'home':
            // run.pages.home();
        break;
        case 'register':
            run.pages.register();
        break;
        case 'rackoot_edit':
            //run.admin.parts.rackootTour();
            // run.admin.parts.tilesSuggestedVisibility();
            run.admin.parts.rackootRelocateTools();
            run.admin.parts.rackootTilesSize();
            run.admin.parts.tileDescription();
            run.admin.parts.rackootEdit();
            run.admin.parts.rackootButtonShare();
            run.admin.parts.rackootManageTiles();
            run.admin.parts.rackootDelete();
            run.admin.parts.tileTypeFileUpload();
            if (module_enabled('rackoot_clone')) {
                run.admin.parts.rackootClone();
            }
            run.admin.parts.rackootDropUrl();
            run.admin.parts.rackootFavicons();
            run.admin.parts.rackootControls();
            if (module_enabled('ai')) {
                run.admin.parts.rackootAiTileSuggestions();
            }
        break;
        case 'rackoot_demo':
            run.admin.pages.rackootView();
            run.admin.parts.rackootTilesSize();
            run.admin.parts.rackootViewUnloggedInviteMessage();
            run.admin.parts.tileDescription();
            run.admin.parts.rackootButtonShare();
            run.admin.parts.rackootFavicons();
            run.admin.parts.rackootControls();
        break;
        case 'rackoot_view_shared':
            run.admin.pages.rackootViewShared();
            run.admin.parts.rackootTilesSize();
            if (module_enabled('rackoot_import')) {
                run.admin.parts.rackootImport();
            }
            run.admin.parts.rackootFollow();
            run.admin.parts.rackootViewUnloggedInviteMessage();
            run.admin.parts.tileDescription();
            run.admin.parts.rackootButtonShare();
            run.admin.parts.rackootFavicons();
            run.admin.parts.rackootControls();
            run.admin.parts.tileSuggest();
        break;
        case 'edit_profile':
            run.admin.parts.avatarEditor();
        break;
        case 'crop_avatar':
            run.admin.pages.avatarCrop();
        break;
        case 'change_password':
            run.parts.profileChangePassword();
            run.parts.hideShowPassword();
        break;
        case 'superadmin_user_password_change':
            run.parts.hideShowPassword();
        break;
        case 'payment_methods':
            run.admin.managePaymentMethods()
        break;
        case 'tiles_suggestions_manage':
            // run.admin.parts.tilesSuggestionsManage();
        break;
        case 'superadmin_user_create_manually':
            run.parts.hideShowPassword();
        break;
        case 'admin_api_dashboard':
            run.admin.pages.apiDashboard();
        break;
        case 'extension_chrome_authorizing':
            // run.admin.pages.extensionChromeAuthorizing();
        break;
        case 'superadmin_tools_create':
        case 'superadmin_tools_edit':
            run.superadmin.parts.toolEditor();
        break;
        case 'edit_plan':
            //run.admin.pages.accountPlanDashboard();
            run.admin.pages.accountPlanCheckout();
        break;
        case 'branding_editor':
            run.pages.brandingEditor();
        break;
        default:
        break;
    }
});
